/* eslint semi:0 */
import { getPlatform } from '../../../utils/ua'
import { path } from '../../../utils/window'
import userStore from '../../stores/userStore'
import { get as getFromPdo } from '../../../application/pageDataObject'
import { external as externalScriptLoader } from '../../../utils/script'
import { HEART_BEAT_PERIOD } from '../../stores/analytics/analyticsStore'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { queryString } from '../../../utils/window'
import { info } from '../../../application/console'

const { debugAnalyticsClickHandler } = queryString
const CUSTOM_DIMENSIONS = {
  SESSION: {
    PLATFORM: 'dimension1',
    USER_LOGGED_IN: 'dimension3',
  },
  HIT: {
    POST_TEMPLATE: 'dimension2',
  },
}
const YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS = ['event', 'Y! DF']
const googleAnalytics = externalScriptLoader.load({ name: 'googleAnalytics', loadNow: true })

export default class GoogleAnalyticsService extends AnalyticsBaseService {
  constructor(options = {}) {
    super(options)
    this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.PLATFORM, getPlatform())
    this.setCustomDimension(
      CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN,
      userStore.isLoggedIn ? 'loggedIn' : 'loggedOut'
    )
    this.existingUserAuthenticated = this.newUserAuthenticated = this.userAuthenticated
  }

  get className() {
    return 'GoogleAnalyticsService'
  }

  riddleEmbedMessage({ payload: { category, label } }) {
    return this.trackEvent('event', 'riddle', category, label)
  }

  pageViewed() {
    this.trackEvent('pageview')
  }

  slotRendered(action) {
    if (action.adId === 'Interstitial') {
      this.trackEvent('event', 'Ads', 'Interstitial', 'Display', { nonInteraction: true })
    }
  }

  heartBeat() {
    const millisecondsPassed = this.store.heartbeatsCount * HEART_BEAT_PERIOD
    this.trackEvent('event', 'Post', 'Read', `${millisecondsPassed / 1000} seconds`)
  }

  socialShare(action) {
    const position = action.e.target.parentNode.className
    const shareTarget = action.type.split(':').pop()
    this.trackEvent('social', shareTarget, position, path)
  }

  analyticsActionsClickEvent(action) {
    const dataToSend = Object.entries(action.state.payload).reduce(
      (acc, [key, value]) => [...acc, value],
      []
    )

    if (debugAnalyticsClickHandler) {
      info('CLICK SERVICE RECIEVED ACTION WITH PAYLOAD: ', action.state.payload)
      info('SENDING TO GA: ', ['event', ...dataToSend])
    }

    this.trackEvent.apply(this, ['event', ...dataToSend])
  }

  jwplayerAnalytics({ payload: { eventName, videoId } }) {
    this.trackEvent('event', 'Article page', eventName, videoId)
  }

  //videoPlay(action){
  //  this.jwplayerAnalytics(action)
  //}
  //
  //videoPause(action){
  //  this.jwplayerAnalytics(action)
  //}
  //
  //videoComplete(action){
  //  this.jwplayerAnalytics(action)
  //}
  //
  //videoPause(action){
  //  this.jwplayerAnalytics(action)
  //}
  //
  //videoError(action){
  //  this.jwplayerAnalytics(action)
  //}
  //
  //videoBufferChange({ payload: { eventName, videoId, buffer } }){
  //  this.trackEvent('event', 'Article Page', eventName, `videoId: ${videoId}, buffered: ${buffer.bufferPercent}`);
  //}

  scrollAnchorReached(action) {
    this.reportOnce(action, () => {
      this.setCustomDimension(CUSTOM_DIMENSIONS.HIT.POST_TEMPLATE, getFromPdo('post.template'))
      this.trackEvent('event', 'Scroll', 'Reached', action.payload.anchor)
    })
  }

  userAuthenticated(action) {
    if (!action.isReauthenticated) {
      this.trackEvent('event', 'User', 'Logged In', null, null, { sessionControl: 'end' })
      this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedIn')
    }
  }

  fbLogin(action) {}

  logout(action) {
    // on user logged out
    this.trackEvent('event', 'User', 'Logged out', null, null, { sessionControl: 'end' })
    this.setCustomDimension(CUSTOM_DIMENSIONS.SESSION.USER_LOGGED_IN, 'loggedOut')
  }

  vote(action) {}

  placeBet(action) {}

  tournamentGetTournamentsFeed({ state: { tournaments: { length: numberOfTournaments } } }) {
    if (numberOfTournaments) {
      this.trackEvent(...YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS, 'view', 'contest widget')
    }
  }
  tournamentSelectTournament(action) {
    this.trackEvent(...YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS, 'enter clicked', 'contest widget')
  }
  tournamentLoadMore(action) {
    this.trackEvent(...YAHOO_FANTASY_TOURNAMENTS_BASE_PARAMS, 'show more', 'contest widget')
  }

  goToMessengerBot({ state: { displayMessage } }) {
    this.trackEvent('event', 'FB bot', 'button click', displayMessage)
  }

  reactionsDisplay(action) {
    const reactionsCampaign = getFromPdo('post.reactions.campaign.name', '')
    const buttonLocation = Object.keys(action.state.reactionsComponentState)[0]
    this.trackEvent(
      'event',
      `Reactions Web ${reactionsCampaign}`,
      'Reaction Button Click',
      buttonLocation
    )
  }

  reactionsSendVote(action) {
    const { state: actionState } = action
    const reactionsCampaign = getFromPdo('post.reactions.campaign.name', '')
    const { componentPosition: buttonLocation, selectedReaction: reactionId } = actionState
    this.trackEvent(
      'event',
      `Reactions Web ${reactionsCampaign}`,
      `Reaction Selection ${buttonLocation}`,
      reactionId
    )
  }

  jwplayerEvent(action) {}

  setCustomDimension(dimension, value) {
    googleAnalytics(() => window.ga('set', dimension, value))
  }

  trackEvent(...args) {
    args.unshift('send')
    this.logAnalytics(...args)
    googleAnalytics(() => window.ga(...args))
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/googleAnalyticsService.js